import io from "socket.io-client";
import environment from "../environment";

const socketModel = io(environment.chat_api, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export default socketModel;
